export default [
    { name: "Red", value: "red" },
    { name: "Yellow", value: "yellow" },
    { name: "Green", value: "limegreen" },
    { name: "Blue", value: "lightblue" },
    { name: "Violet", value: "violet" },
    { name: "Teal", value: "turquoise" },
];
